import * as React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import styled from "styled-components";
import Scenes from "./components/Scenes/Scenes";
import { useRef, useState } from "react";
import MixerPopup from "./components/MixerPopup/MixerPopup";
import Youtube from "./components/Youtube/Youtube";
import Chat from "./components/Chat/ChatPopup";
import ChatPopup from "./components/Chat/ChatPopup";
import Timer from "./components/Timer/Timer";
import Note from "./components/Note/Note";
import { menuData } from "./MenuData";
// import ChatRoom from "./components/ChatRoom";
import { useAuthContext } from "../../context/useAuthContext";
import { toast } from "react-toastify";
export interface showPopupType {
  showMixer: boolean;
  showYoutubePop: boolean;
  showScenesPopup: boolean;
  showChatPopup: boolean;
  showNotePopup: boolean;
  showTimerPopup: boolean;
}

function Sidebar() {
  const { state } = useAuthContext();
  const isAuthenticated = state?.isAuthenticated;
  const [show, setShow] = React.useState<showPopupType>({
    showMixer: false,
    showYoutubePop: false,
    showScenesPopup: false,
    showChatPopup: false,
    showNotePopup: false,
    showTimerPopup: false,
  });
  const menuRef = useRef<HTMLDivElement>(null);
  const handleMenuChange = (index: number) => {
    if (!isAuthenticated && index === 1) {
      toast.warn("You need to login!", {
        autoClose: 1500,
        position: "top-center",
      });
    } else {
      setShow((prevShow: showPopupType) => {
        return {
          ...prevShow,
          showMixer: index === 0 ? !prevShow.showMixer : prevShow.showMixer,
          showChatPopup:
            index === 1 ? !prevShow.showChatPopup : prevShow.showChatPopup,
          showScenesPopup:
            index === 2 ? !prevShow.showScenesPopup : prevShow.showScenesPopup,
          showYoutubePop:
            index === 3 ? !prevShow.showYoutubePop : prevShow.showYoutubePop,
          showTimerPopup:
            index === 4 ? !prevShow.showTimerPopup : prevShow.showTimerPopup,
          showNotePopup:
            index === 5 ? !prevShow.showNotePopup : prevShow.showNotePopup,
        };
      });
    }
  };
  React.useEffect(() => {
    if (!isAuthenticated) {
      setShow((prevShow: showPopupType) => {
        return {
          ...prevShow,
          showChatPopup: false,
        };
      });
    }
  }, [isAuthenticated]);

  return (
    <StyledSidebar className={sidebarClass}>
      <div className="px-2 mr-6 relative py-3 rounded-lg bg-alphaBg flex flex-col gap-y-7 items-center">
        {menuData
          .filter((item) => item.id < 3)
          .map((item) => {
            return (
              <Tippy key={item.id} placement="left" content={item.title}>
                <div
                  ref={menuRef}
                  onClick={() => handleMenuChange(item.id)}
                  className="flex flex-shrink-0 overflow-hidden w-6  cursor-pointer menu-mixer  select-none justify-center items-center "
                >
                  <img
                    className="text-sm icon-mixer-out"
                    src={item.icon}
                    alt=""
                  />
                  <img
                    className="text-sm icon-mixer-in hidden"
                    src={item.icon_hovered}
                    alt=""
                  />
                </div>
              </Tippy>
            );
          })}
        <div className="line w-full h-[1px] bg-[#fff2]"></div>
        {menuData
          .filter((item) => item.id >= 3)
          .map((item) => {
            return (
              <Tippy key={item.id} placement="left" content={item.title}>
                <div
                  onClick={() => handleMenuChange(item.id)}
                  className="flex flex-shrink-0 overflow-hidden w-6 menu-youtube  cursor-pointer  select-none justify-center items-center "
                >
                  <img
                    className="text-sm icon-youtube-out"
                    src={item.icon}
                    alt=""
                  />
                  <img
                    className="text-sm icon-youtube-in hidden"
                    src={item.icon_hovered}
                    alt=""
                  />
                </div>
              </Tippy>
            );
          })}

        {show?.showMixer && (
          <MixerPopup showPopMixer={show.showMixer} onShow={setShow} />
        )}
        {/* <ChatPopup showChatPopup={show?.showChatPopup} onShow={setShow} /> */}
        {show?.showScenesPopup && (
          <Scenes onShow={setShow} show={show.showScenesPopup} />
        )}
        {show?.showYoutubePop && (
          <Youtube show={show.showYoutubePop} onShow={setShow} />
        )}
        {show?.showTimerPopup && (
          <Timer showTimerPopup={show?.showTimerPopup} onShow={setShow} />
        )}
        {show?.showNotePopup && (
          <Note showNotePopup={show?.showNotePopup} onShow={setShow} />
        )}
        {/* <ChatRoom showChatPopup={show?.showChatPopup} onShow={setShow} /> */}
      </div>
    </StyledSidebar>
  );
}
export default React.memo(Sidebar);
const sidebarClass = `absolute top-2/4 w-24 -translate-y-2/4 right-0 z-10 flex items-center justify-end w-[48px] z-[100] h-full`;
const StyledSidebar = styled.div`
  .menu-mixer {
    &:hover .icon-mixer-out {
      display: none;
    }
    &:hover .icon-mixer-in {
      display: block;
    }
  }
  .menu-templates {
    &:hover .icon-templates-out {
      display: none;
    }
    &:hover .icon-templates-in {
      display: block;
    }
  }
  .menu-scenes {
    &:hover .icon-menuscenes-out {
      display: none;
    }
    &:hover .icon-menuscenes-in {
      display: block;
    }
  }
  .menu-youtube {
    &:hover .icon-youtube-out {
      display: none;
    }
    &:hover .icon-youtube-in {
      display: block;
    }
  }
  .menu-timer {
    &:hover .icon-timer-out {
      display: none;
    }
    &:hover .icon-timer-in {
      display: block;
    }
  }
  .menu-notes {
    &:hover .icon-notes-out {
      display: none;
    }
    &:hover .icon-notes-in {
      display: block;
    }
  }
  .popup-menu {
    backdrop-filter: blur(30px);
    -webkit-backdrop-filter: blur(30px);
  }
  .range-volume {
    height: 6px;
    color: #f3a952;
  }
  .MuiSlider-rail {
    color: hsla(0, 0%, 100%, 0.7);
  }
  .track-slider {
    margin-bottom: 0px;
  }
  .MuiSlider-thumb {
    width: 16px;
    height: 16px;
  }
  .level-thumb {
    filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
    -webkit-filter: drop-shadow(0 4px 4px rgba(0, 0, 0, 0.25));
  }
  input[type="range"] {
    -webkit-appearance: none;
    background-color: initial;
    display: flex;
    height: 6px;
    justify-content: center;
    position: relative;
    width: 100%;
    z-index: 100;
    height: 24px;
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
  .input-range {
    opacity: 0;
    height: 24px;
  }

  .track {
    width: 80px;
    height: inherit;
  }
`;
